import React, { useEffect, useState } from 'react';
import Div100vh from 'react-div-100vh';
import styled from 'styled-components';
import ScreenOrientation from '~/pages/components/ui/screen-orientation';
import Main from './main';

type IProps = {
  children?: React.ReactNode;
  $background?: string;
  backgroundWrapper?: string;
  backgroundSize?: string;
  $menuWithLogo?: boolean;
  $withoutMenu?: boolean;
  $withoutScreenOrientation?: boolean;
};

function Layout(props: IProps) {
  const { children, $background, $withoutScreenOrientation } = props;
  const [screenOrientation, setScreenOrientation] =
    useState<string>(getOrientation());
  const [innerHeight, setInnerHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    setInnerHeight(window.innerHeight);

    window.addEventListener('resize', resize);
    window.addEventListener('orientationchange', resize);

    return () => {
      window.removeEventListener('resize', resize);
      window.removeEventListener('orientationchange', resize);
    };
  }, []);

  function resize() {
    setScreenOrientation(getOrientation());
    setInnerHeight(window.innerHeight);
  }

  function getOrientation() {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (window.screen.orientation === undefined) {
      if (window.innerHeight > window.innerWidth) return 'portrait';

      return 'landscape';
    }

    return window.screen.orientation.type.split('-')[0];
  }

  return (
    <>
      {!$withoutScreenOrientation &&
      innerHeight &&
      innerHeight < 550 &&
      screenOrientation === 'landscape' ? (
        <ScreenOrientation />
      ) : (
        <Container $background={$background}>
          <WrapperBlur>
            <Main {...props}>{children}</Main>
          </WrapperBlur>
        </Container>
      )}
    </>
  );
}

const Container = styled(Div100vh)<{ $background?: string }>`
  align-items: center;
  background-image: ${({ $background }) =>
    $background ? `url('${$background}')` : 'none'};
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  overflow: hidden;
  width: 100%;
`;

const WrapperBlur = styled.div`
  align-items: center;
  background-image: linear-gradient(
    to bottom,
    rgba(12, 82, 132, 0) 0%,
    rgba(22, 183, 203, 0.8) 100%
  );
  backdrop-filter: blur(10px);
  background-blend-mode: multiply;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

// const BgBluredImage = styled.div<{ background?: string }>`
//   display: none;
//   @media screen and (min-aspect-ratio: 16/27) {
//     display: block;
//     width: 100%;
//     position: absolute;
//     top: 0;
//     left: 0;
//     height: 100%;
//     background-image: ${({ background }) =>
//       background ? `url('${background}')` : 'none'};
//     pointer-events: none;
//     background-size: cover;
//     background-repeat: no-repeat;
//     background-position: center;
//     filter: blur(10px);
//   }
// `;

export default Layout;
